define( 'application/delegate/ApplicationDelegate', [
    'helpers/FormatHelper',
    'specific/pushdetails/models/PushDetailsModel',
    'specific/staticproduct/models/StaticProductModel',
    'specific/instagram/models/InstagramModel',
    'specific/popin-rules/models/PopinRulesModel',
    'specific/mosaic/models/MosaicModel',
    'specific/pushdetails/views/PushDetailsView',
    'specific/staticproduct/views/StaticProductView',
    'specific/instagram/views/InstagramView',
    'specific/popin-rules/views/PopinRulesView',
    'specific/mosaic/views/MosaicView'
], function ( FormatHelper, PushDetailsModel, StaticProductModel, InstagramModel, PopinRulesModel, MosaicModel,
    PushDetailsView, StaticProductView, InstagramView, PopinRulesView, MosaicView ) {

    var applicationDatas = {};
    var config = {};
    var callbacks = {};

    var initialize = function ( options ) {
        applicationDatas = options.datas;
        config = options.config;
        callbacks = options.callbacks;
    };

    var createModelFromData = function ( data ) {

        if ( !_.isString( data.type ) || !_.isString( data.viewId ) ) {
            return;
        }

        data.config = config;
        data.assets_url = config.assets_url;

        data.isMobile = data.config.deviceEnv === 'mobile';
        data.isTablet = data.config.deviceEnv !== 'mobile' && $( window ).width() <= 1024;
        // data.isIphone = /(iPhone)/g.test( navigator.userAgent );
				data.isIphone = false; // deactivate iphone mode because of mmm player bug;
        data.isEcrinHorizon = applicationDatas.header.ecrinHorizon || false;

        if( data.isIphone ) {
            data.isIphone = !/(Line)/g.test( navigator.userAgent );
        }

        var _model = null;
        var modelDatas = $.extend( true, {}, data );

        switch ( data.type ) {
            case "pushdetails":
                if (modelDatas.config.locale === 'zh_cn') {
                    modelDatas.datas.original_source = "#";
                }

                _model = new PushDetailsModel(modelDatas);

                break;

            case "staticproduct":
                _model = new StaticProductModel(modelDatas);
                break;

            case "instagram":
                _model = new InstagramModel(modelDatas);
                break;

            case "mosaicview":
                if (data.isIphone) {
                    _.each(modelDatas.pictures, function(item){
                        var link = item.link;

                        if (link) {
                            id = link.replace('#popin/', '');
                            item.videoInfos = _.findWhere(applicationDatas.popins, {
                                viewId: id
                            });
                            item.videoInfos.video.autoplay = false;
                        }
                    });
                }

                _model = new MosaicModel(modelDatas);

                break;

            case "productview":
                data.wsRoot = config.ws_quickbuy_product[ config.deviceEnv ];
                data.base_url = config.base_url;
                data.allowResponsive = true;
                data.currentSiteTitle = "Dior Gallery Backstage";
                data.shouldTrackImpression = false;

                if ( data.isMobile ) {
                    data.onAddToCartCallback = _.bind(function() {
                        if (callbacks.addToCartCallback) {
                            callbacks.addToCartCallback();
                        }
                    });
                }

                if (config.retailers) {
                    data.retailers = _.reject( config.retailers, function(retailer) { return !retailer.link; });
                }

                if ( config.ecommerce === "shop" ) {
                    data.popinTitle = applicationDatas.wording.productPopinTitle;
                }

                if( config.ecommerce === "none" ) {
                    data.showSwatch = false;
                    data.allowQuickBuy = false;
                    data.showPrice = false;
                    data.showPriceFrom = false;
                    data.showBtnAction = false;
                    data.showKnowmore = true;
                }

                if( config.ecommerce === "retailer" ) {
                    data.showRetailers = true;
                    data.showSwatch = false;
                    data.allowQuickBuy = false;
                    data.showPrice = false;
                    data.showPriceFrom = false;
                    data.showKnowmore = data.viewId !== 'maz-nav-product';
                    data.showBtnAction = false;
                }

                if ( data.suffixClass === "basic-simple" || data.suffixClass === "basic-multi" ) {
                    data = _.extend( data, {
                        "showDescription": false,
                        "showDelivery": false,
                        "showSwatch": false,
                        "showLabel": false,
                        "showHashtag": false,
                        "showQuantity": false,
                        "showBtnAction": config.ecommerce === 'shop',
                        "allowQuickBuy": config.ecommerce === 'shop',
                        "showPrice": true,
                        // "showPrice": config.ecommerce === 'shop',
                        "showRetailers": config.ecommerce === 'retailer'
                    } );
                }

                if (data.viewId.indexOf('quickbuy') !== -1) {
                    data.showDescription = true;
                    data.cutDescription = true;
                    data.showPriceFrom = false;
                    data.showPrice = false;

                    if( data.isMobile ) {
                        data.cutDescriptionMaxChars = 120;
                        data.showDelivery = false;
                        data.allowResponsive = true;
                    }
                }

                break;

            case "videoview":
                if (!data.isIphone) {
                    data.video.autoplay = true;
                }

                // Only for MMM video
                if (data.video && data.video.type === "mmm") {
                    // Conf the share feature
                    data.video.shareUrl = window.location.href;
                    data.video.shareTitle = applicationDatas.widget.facebookShare.caption;
                    data.video.featureShare = {
                        shareUrl: data.video.shareUrl,
                        shareImg: data.video.shareImg,
                        shareTitle: data.video.shareTitle
                    };

                    // When a popin is re-opened don't add assets_url another time !!!
                    if(!data.assetFixed) {
                        // Update video poster url with assets_url
                        data.video.poster = config.assets_url + data.video.poster;

                        // Add some swf files
                        data.video.swfPath = config.assets_url + 'swf/player_mmm.swf';
                        data.video.swfZPath = config.assets_url + 'swf/ZeroClipboard.swf';
                        data.assetFixed = true;
                    }

                    var mmmLocale = applicationDatas.wording.mmm;
                    data.video.locale = {
                        'fullscreen': mmmLocale.fullscreen,
                        'volume': mmmLocale.volume,
                        'share': mmmLocale.share,
                        'subtitles': mmmLocale.subtitles
                    };
                }


                // Add subtitle
                if (data.video.subtitle) {
                    if (!data.subtitleFixPath) {
                        data.video.subtitle = config.assets_url + data.video.subtitle;
                        data.subtitleFixPath = true;
                    }

                    // For vtt support
                    data.video.subtitleVTT = {
                        "src": data.video.subtitle.replace('.xml', '.vtt'),
                        "srclang": config.language,
                        "label": 'Subtitles'
                    };

                    data.video.featureSubtitles = true;
                    data.video.subtitlesEnabled = true;
                    data.video.substitleLang = config.language;
                    data.video.subtitleLabel = 'Subtitles';
                }

                $.extend( true, modelDatas.video, data.video );
                break;

            case "popin-rules":
                _model = new PopinRulesModel(modelDatas);
                break;

            default:
                break;
        }

        if ( _.isNull( _model ) && config.debug ) {
            console.warn( "[Application Delegate -> createModelFromData] Can't create model of this type", data.type );
        }

        return _model;
    };

    var createViewFromModel = function ( _model ) {

        if ( _.isNull( _model ) || !_.isString( _model.get( 'type' ) ) || !_.isString( _model.get( 'viewId' ) ) ) {
            return;
        }

        var _view = null;

        switch ( _model.get( 'type' ) ) {
            case "pushdetails":
                _view = new PushDetailsView({
                    model: _model
                });
                break;

            case "staticproduct":
                _view = new StaticProductView({
                    model: _model
                });
                break;

            case "instagram":
                _view = new InstagramView({
                    model: _model
                });
                break;

            case "popin-rules":
                _view = new PopinRulesView({
                    model: _model
                });
                break;

            case "mosaicview":
                _view = new MosaicView({
                    model: _model
                });
                break;

            default:
                break;
        }

        if ( _.isNull( _view ) && config.debug) {
            console.warn( "[Application Delegate -> createViewFromModel] Can't create view of this type", _model.get( 'type' ) );
        }

        return _view;
    };

    return {
        initialize: initialize,
        createModelFromData: createModelFromData,
        createViewFromModel: createViewFromModel
    };
} );
